import {ChangeDetectionStrategy, Component, computed} from "@angular/core"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {SliderComponent} from "@common/components/inputs/slider/slider.component"
import {ToggleComponent} from "@common/components/buttons/toggle/toggle.component"
import {ButtonComponent} from "@common/components/buttons/button/button.component"
import {OperatorTiling} from "@app/textures/texture-editor/operator-stack/operators/tiling/operator-tiling"
import {AsyncPipe} from "@angular/common"
import {MatTooltipModule} from "@angular/material/tooltip"
import {OperatorPanelBase} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator-panel-base"
import {isApple} from "@cm/browser-utils"
import {HintComponent, HintTypes} from "@common/components/hint/hint.component"
import {ViewMode} from "@app/textures/texture-editor/operator-stack/operators/tiling/toolbox/tiling-area/spatial-mapping-item"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-tiling-panel",
    imports: [InspectorSectionComponent, SliderComponent, ToggleComponent, ButtonComponent, AsyncPipe, MatTooltipModule, HintComponent],
    templateUrl: "./tiling-panel.component.html",
    styleUrl: "./tiling-panel.component.scss",
})
export class TilingPanelComponent extends OperatorPanelBase<OperatorTiling> {
    protected readonly ViewMode = ViewMode

    readonly $isDebugEnabled = computed(() => this.$operator().callback.isDebugEnabled ?? false)

    readonly $isAlignmentDataAvailable = computed(() => this.$operator().isAlignmentDataAvailable)

    readonly $isComputingAlignment = computed(() => this.$operator().isComputingAlignment)

    readonly $hasAlignmentControlPoints = computed(() => this.$operator().hasAlignmentControlPoints)

    get hasLowQualityAlignment(): boolean {
        return this.$operator().hasLowQualityAlignment
    }

    readonly $canTraceHelperLines = computed(() => !this.$operator().isTracingHelperLines)

    createHelperLineClicked() {
        this.$operator().setTraceHelperLineEditModeEnabled(!this.$operator().isCreatingHelperLineTrace)
    }

    readonly $isCreatingHelperLineTrace = computed(() => this.$operator().isCreatingHelperLineTrace)

    readonly $hasSelectedHelperLines = computed(() => this.$operator().hasSelectedHelperLines)

    retraceSelectedHelperLinesClicked() {
        void this.$operator().retraceSelectedHelperLines()
    }

    protected readonly isApple = isApple
    protected readonly HintTypes = HintTypes
}
